// Copyright 2025, Imprivata, Inc.  All rights reserved.

const getRelativeTime = (timestamp: string, locale = 'en') => {
  const now = new Date();
  const past = new Date(timestamp);

  // Guard against invalid/epoch timestamps (before year 2000)
  const EPOCH_THRESHOLD = new Date('2000-01-01').getTime();
  if (past.getTime() < EPOCH_THRESHOLD) {
    return '';
  }

  const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  const timeUnits = [
    { unit: 'year', seconds: 31536000 },
    { unit: 'month', seconds: 2592000 },
    { unit: 'day', seconds: 86400 },
    { unit: 'hour', seconds: 3600 },
    { unit: 'minute', seconds: 60 },
  ] as const;

  for (const { unit, seconds } of timeUnits) {
    const interval = Math.floor(diffInSeconds / seconds);

    if (interval >= 1) {
      return rtf.format(-interval, unit);
    }
  }

  if (locale.toLowerCase().split('-')[0] === 'en') {
    return 'just now';
  }

  return rtf.format(0, 'second');
};

export default getRelativeTime;
